<div class="flex border-b-2 border-primary">
  <div class="flex-1 p-2">
    <h1 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 text-center">Manage Location Groups Domain Whitelist</h1>
    <p class="font-normal text-gray-700 text-center">Search by location group to manage all whitelisted domains</p>
  </div>

  @if (selectedLocationGroup(); as loc) {
    <div class="flex-1 flex items-center pl-2 italic">{{ loc.name }}</div>
  }
</div>

<div class="flex h-full">
  <div class="flex-1 flex flex-col h-[600px] border-r-2 border-b-2 border-primary">
    <div class="flex mx-[-1px]">
      <input
        panInput
        color="primary"
        class="w-full !rounded-none mt-[-1px]"
        placeholder="Filter {{ locationGroups().length }} locations groups..."
        [(ngModel)]="locationGroupFilter"
        data-testid="location-group-filter-input"
      />
    </div>

    <div class="flex-1 overflow-hidden overflow-y-auto">
      @if (locationGroups().length === 0 && !hasLoadedUserLocationGroups()) {
        <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> &nbsp;Loading... </app-pan-blank-slate>
      } @else if (locationGroups().length === 0 && hasLoadedUserLocationGroups()) {
        <app-pan-blank-slate>You do not have access to any location groups.</app-pan-blank-slate>
      } @else if (visibleLocationGroups().length === 0 && hasLoadedUserLocationGroups()) {
        <app-pan-blank-slate>No locations match your query.</app-pan-blank-slate>
      } @else {
        <cdk-virtual-scroll-viewport itemSize="50" class="h-full">
          <div
            *cdkVirtualFor="let item of visibleLocationGroups()"
            class="h-[50px] p-3 flex flex-col justify-center border-b-2 cursor-pointer"
            [class.bg-primary-no-hover]="item === selectedLocationGroup()"
            (click)="selectLocationGroup(item)"
          >
            <div>
              {{ item.name }}
            </div>

            <div class="text-sm italic">
              {{ item.id }}
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      }
    </div>
  </div>

  <div class="flex-1 h-[600px] overflow-hidden overflow-y-auto border-r-2 border-b-2 border-primary">
    @if (!selectedLocationGroup()) {
      <app-pan-blank-slate>Select a location group to see whitelisted domains for it.</app-pan-blank-slate>
    } @else if (selectedLocationGroup() && selectedLocationGroupDomains().length === 0) {
      <app-pan-blank-slate>
        There are no whitelisted domains on this location group.

        <app-pan-button icon="add" color="primary" fill="outline" (click)="addDomainModal.show()">Add one</app-pan-button>
      </app-pan-blank-slate>
    } @else {
      <div class="flex mx-[-1px] items-center relative">
        <input
          panInput
          color="primary"
          class="w-full !rounded-none mt-[-1px]"
          placeholder="Filter {{ selectedLocationGroupDomains().length }} domains..."
          [(ngModel)]="domainFilter"
          data-testid="domain-filter-input"
        />

        <app-pan-button class="absolute right-[10px]" size="sm" color="info" (click)="addDomainModal.show()" data-testid="add-domain-button">Add</app-pan-button>
      </div>
      @if (filteredDomains().length === 0) {
        <app-pan-blank-slate>No domains match your query.</app-pan-blank-slate>
      } @else {
        <cdk-virtual-scroll-viewport [itemSize]="44" class="h-[560px]">
          <div *cdkVirtualFor="let item of filteredDomains()" class="h-[44px] px-3 py-1 flex items-center border-b-2 flex-row">
            <div class="flex-1 flex flex-col">
              <div>{{ item }}</div>
            </div>

            <app-pan-button color="danger" icon="delete" [swal]="removeDomainSwal" [attr.data-testid]="'delete-domain-button-' + item"></app-pan-button>

            <swal
              #removeDomainSwal
              title="Remove Whitelisted Domain?"
              text="Are you sure you want to remove this domain from {{ selectedLocationGroup().name }}?"
              icon="warning"
              confirmButtonText="Yes, Remove"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="removeDomain(item)"
            >
            </swal>
          </div>
        </cdk-virtual-scroll-viewport>
      }
    }
  </div>
</div>

<app-pan-modal #addDomainModal (modalClose)="newDomain.set('')">
  <div header>Add Domain</div>

  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>Domain</app-pan-floating-label>
      <input
        type="text"
        [(ngModel)]="newDomain"
        panInput
        placeholder="example.company.com..."
        data-testid="new-domain-input"
      />
    </app-pan-form-control>
  </div>

  <div footer>
    <button panButton color="primary" (click)="submitModal()" [disabled]="!canSubmitModal()">Add Domain</button>
  </div>
</app-pan-modal>
